import React from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface ConnectionMailProps {
  connectionData: any;
  handleParameterChange: (key: string, value: any) => void;
}

const ConnectionMail: React.FC<ConnectionMailProps> = ({ connectionData, handleParameterChange }) => {
  const { t } = useTranslation();
  return (
    <>
      <Form.Group controlId="sub_type">
        <Form.Label>Sub Type</Form.Label>
        <Form.Control
          as="select"
          value={connectionData.connection_parameters.sub_type || ''}
          onChange={(e) => handleParameterChange('sub_type', e.target.value)}
        >
          <option value="">Select subcategory</option>
          <option value="Azure">Azure</option>
          <option value="SMTP">SMTP</option>
        </Form.Control>
      </Form.Group>

      {connectionData.connection_parameters.sub_type === 'Azure' && (
        <>
          <Form.Group controlId="client_id">
            <Form.Label>Client ID</Form.Label>
            <Form.Control
              type="text"
              value={connectionData.connection_parameters.client_id || ''}
              onChange={(e) => handleParameterChange('client_id', e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="secret">
            <Form.Label>Secret</Form.Label>
            <Form.Control
              type="text"
              value={connectionData.connection_parameters.secret || ''}
              onChange={(e) => handleParameterChange('secret', e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="tenant_id">
            <Form.Label>Tenant ID</Form.Label>
            <Form.Control
              type="text"
              value={connectionData.connection_parameters.tenant_id || ''}
              onChange={(e) => handleParameterChange('tenant_id', e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="sent_from_address">
            <Form.Label>Sent from address</Form.Label>
            <Form.Control
              type="text"
              value={connectionData.connection_parameters.sent_from_address || ''}
              onChange={(e) => handleParameterChange('sent_from_address', e.target.value)}
            />
          </Form.Group>
        </>
      )}
      {connectionData.connection_parameters.sub_type === 'SMTP' && (
        <>
          <Form.Group controlId="host">
            <Form.Label>Host</Form.Label>
            <Form.Control type="text" value={connectionData.connection_parameters.host || ''} onChange={(e) => handleParameterChange('host', e.target.value)} />
          </Form.Group>

          <Form.Group controlId="port">
            <Form.Label>Port</Form.Label>
            <Form.Control type="text" value={connectionData.connection_parameters.port || ''} onChange={(e) => handleParameterChange('port', e.target.value)} />
          </Form.Group>

          <Form.Group controlId="encryption">
            <Form.Label>Encryption</Form.Label>
            <Form.Control
              as="select"
              value={connectionData.connection_parameters.encryption || ''}
              onChange={(e) => handleParameterChange('encryption', e.target.value)}
            >
              <option value="">Select encryption</option>
              <option value="None">None</option>
              <option value="STARTTLS">STARTTLS</option>
              <option value="SSL/TLS">SSL/TLS</option>
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="sent_from_address">
            <Form.Label>Sent from address</Form.Label>
            <Form.Control
              type="text"
              value={connectionData.connection_parameters.sent_from_address || ''}
              onChange={(e) => handleParameterChange('sent_from_address', e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="username">
            <Form.Label>
              {t('login.username')} ({t('common.optional')})
            </Form.Label>
            <Form.Control
              type="text"
              value={connectionData.connection_parameters.username || ''}
              onChange={(e) => handleParameterChange('username', e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="password">
            <Form.Label>
              {t('login.password')} ({t('common.optional')})
            </Form.Label>
            <Form.Control
              type="password"
              value={connectionData.connection_parameters.password || ''}
              onChange={(e) => handleParameterChange('password', e.target.value)}
            />
          </Form.Group>
        </>
      )}
    </>
  );
};

export default ConnectionMail;
